import React, { useState, useEffect } from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Field = ({ label, value, onChange, multiline, rows = 3, hint }) => (
  <div>
    <Label>{label}</Label>
    {hint && <p className="text-xs text-gray-400 mb-1">{hint}</p>}
    {multiline
      ? <Textarea rows={rows} value={value || ''} onChange={e => onChange(e.target.value)} className="mt-1" />
      : <Input value={value || ''} onChange={e => onChange(e.target.value)} className="mt-1" />}
  </div>
);

export const AdminAboutContent = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/content/about`).then(r => setContent(r.data)).catch(console.error);
  }, []);

  const set = (key, val) => setContent(prev => ({ ...prev, [key]: val }));

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/content/about`, { data: content });
      toast.success('About page updated');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  if (!content) return <AdminLayout title="Edit About Page"><div className="py-8 text-center text-gray-400">Loading...</div></AdminLayout>;

  return (
    <AdminLayout title="Edit About Page">
      <div className="max-w-2xl space-y-6">

        <Card className="border-2">
          <CardHeader><CardTitle>Hero Section</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Page Title" value={content.hero_title} onChange={v => set('hero_title', v)} />
            <Field label="Subtitle" value={content.hero_subtitle} onChange={v => set('hero_subtitle', v)} multiline rows={2} />
          </CardContent>
        </Card>

        <Card className="border-2">
          <CardHeader><CardTitle>Our Story Section</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Section Title" value={content.story_title} onChange={v => set('story_title', v)} />
            <Field label="Paragraph 1" value={content.story_p1} onChange={v => set('story_p1', v)} multiline />
            <Field label="Paragraph 2" value={content.story_p2} onChange={v => set('story_p2', v)} multiline />
            <Field label="Paragraph 3" value={content.story_p3} onChange={v => set('story_p3', v)} multiline />
          </CardContent>
        </Card>

        <Card className="border-2">
          <CardHeader><CardTitle>Mission & Values</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Our Mission Text" value={content.mission_text} onChange={v => set('mission_text', v)} multiline rows={4} />
            <Field label="Community First Text" value={content.community_text} onChange={v => set('community_text', v)} multiline rows={4} />
          </CardContent>
        </Card>

        <Card className="border-2">
          <CardHeader><CardTitle>Credentials Section</CardTitle></CardHeader>
          <CardContent>
            <Field label="Credentials Text" value={content.credentials_text} onChange={v => set('credentials_text', v)} multiline rows={4} />
          </CardContent>
        </Card>

        <Button onClick={save} disabled={saving} className="bg-red-600 hover:bg-red-700 text-white w-full">
          {saving ? 'Saving...' : 'Save All Changes'}
        </Button>
      </div>
    </AdminLayout>
  );
};
